import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useRouter } from "next/router";
import { categoriesGql } from "gql/queries";
import { CategoryEntityResponseCollection, SubCategoryEntityResponseCollection } from "gql-types";
import {
  subCategoriesNameListByCategoryNameGql,
  parser,
} from "gql/queries/subCategoriesNameListByCategoryName.gql";
import { selectFilterIcon } from "utils/selectFilterIcon";
import { FilterOptionData } from "../../helpers/filter/filter-options";
import { Platform } from "../../helpers/types";

export function useHeroHooks() {
  const router = useRouter();
  const [subCategories, setSubCategories] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [selectedSubCategory, SetSelectedSubCategory] = useState<string | undefined>(undefined);
  const [selectedCategory, SetSelectedCategory] = useState("categories");
  const [filterOptions, setFilterOptions] = useState({
    platform: undefined,
    hasDelivery: undefined,
    sub_category: {
      name: {
        containsi: undefined,
      },
    },
  });

  const { loading: loadingCategories, data: dataCategories } = useQuery<{
    categories?: CategoryEntityResponseCollection;
  }>(categoriesGql);

  const [isSocialMediaActive, setIsSocialMediaActive] = useState({
    [Platform.FACEBOOK]: false,
    [Platform.INSTAGRAM]: false,
  });

  const { refetch } = useQuery<{
    subCategories?: SubCategoryEntityResponseCollection;
  }>(subCategoriesNameListByCategoryNameGql, {
    variables: { catName: selectedCategory },
    onCompleted: (data) => {
      const _subCategories = parser(data.subCategories);
      setSubCategories(_subCategories);
      SetSelectedSubCategory(_subCategories[0]?.name);
    },
  });

  const getSubCategories = () => {
    refetch({
      variables: { catName: selectedCategory },
    });
  };

  useEffect(() => {
    setFilterOptions({
      ...filterOptions,
      ["sub_category"]: {
        ["name"]: {
          containsi: selectedSubCategory,
        },
      },
    });
  }, [selectedSubCategory]);

  useEffect(() => {
    if (!loadingCategories) {
      setCategories(dataCategories?.categories?.data || []);
    }
  }, [loadingCategories]);

  useEffect(() => {
    selectFilterIcon(filterOptions, setFilterOptions, "INSTAGRAM");
  }, [isSocialMediaActive.INSTAGRAM]);

  useEffect(() => {
    selectFilterIcon(filterOptions, setFilterOptions, "FACEBOOK");
  }, [isSocialMediaActive.FACEBOOK]);

  useEffect(() => {
    setFilterOptions({
      ...filterOptions,
      platform: undefined,
    });
  }, []);

  // Function to change and receive the value of the category option in select attribute
  const handleCategoryChange = ({ target: { value } }) => {
    SetSelectedCategory(value);
  };
  const handleSubCategoryChange = ({ target: { value } }) => {
    SetSelectedSubCategory(value);
  };

  const handleClickDelivery = () => {
    if (filterOptions.hasDelivery === undefined) {
      setFilterOptions({
        ...filterOptions,
        hasDelivery: { eq: true },
      });
    } else {
      setFilterOptions({
        ...filterOptions,
        hasDelivery: undefined,
      });
    }
  };

  const handleClickIcon = (item: FilterOptionData) => {
    if (item) {
      setIsSocialMediaActive({
        ...isSocialMediaActive,
        [item.value]: !isSocialMediaActive[item.value],
      });
    }
  };

  return {
    router,
    subCategories,
    categories,
    selectedSubCategory,
    selectedCategory,
    filterOptions,
    isSocialMediaActive,
    getSubCategories,
    handleCategoryChange,
    handleSubCategoryChange,
    handleClickDelivery,
    handleClickIcon,
  };
}
